(function () {
  var COOKIE_NAME = "amigui_clear_cart";

  function cookieValue(name) {
    var parts = ("; " + document.cookie).split("; " + name + "=");
    if (parts.length < 2) return "";
    return decodeURIComponent(parts.pop().split(";").shift() || "");
  }

  function expireCookie(name) {
    var host = window.location.hostname || "";
    var domain = host.endsWith("myshopify.com") ? host : host.split(".").slice(-2).join(".");
    document.cookie = name + "=; Path=/; Max-Age=0";
    if (domain) {
      document.cookie = name + "=; Path=/; Max-Age=0; Domain=." + domain;
    }
  }

  function clearCart() {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";
    return fetch(root + "cart/clear.js", {
      method: "POST",
      credentials: "same-origin",
      cache: "no-store",
      headers: { Accept: "application/json" },
    })
      .then(function (response) {
        if (!response.ok) throw new Error("No se pudo vaciar el carrito");
        return response.json();
      })
      .then(function (cart) {
        expireCookie(COOKIE_NAME);
        document.dispatchEvent(new CustomEvent("amigui:cart-updated", { detail: cart }));
        document.dispatchEvent(new CustomEvent("cart:updated", { detail: cart }));
        return cart;
      });
  }

  function start() {
    if (cookieValue(COOKIE_NAME) !== "1") return;
    clearCart().catch(function () {
      expireCookie(COOKIE_NAME);
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", start, { once: true });
  } else {
    start();
  }
})();
